import React from 'react'
import { Translate } from '../contexts/Language';

export const Validator = {

    Valid(data, ref = null) {

        let error = Object.entries(data).length === 0 ? { error: true, message: "Invalid entries" } : { error: false, message: "" };

        try {

            Object.keys(data).forEach(function (key) {

                let validator = Validator.Rules[key];

                if (validator)
                    if (validator.Invalid(data[key])) {

                        error = {
                            error: true,
                            message: validator.Message
                        }

                        if (ref !== null)
                            ref.current.elements[key].focus();

                        throw new Error()
                    }

            })
        }
        catch { }

        return error;


    },
    Rules: {
        AccountLogin: {
            Invalid: (value) => {
                return Validator.Conditions.Required(value);
            },
            Message: "Invalid Login ID"
        },
        login: {
            Invalid: (value) => {
                return Validator.Conditions.Required(value) || Validator.Conditions.Numeric(value);
            },
            Message: "Invalid Login ID"
        },
        Password: {
            Invalid: (value) => {
                return Validator.Conditions.Required(value);
            },
            Message: "Password can not be empty."
        },
        Email: {
            Invalid: (value) => {
                return !(/[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}/.test(value))
            },
            Message: "Invalid Email Address."
        },
        amount: {
            Invalid: (value) => {
                return Validator.Conditions.Required(value) || value <= 0 || Validator.Conditions.Numeric(value);
            },
            Message: "Invalid amount."
        },
        fromAccount: {
            Invalid: (value) => {
                return Validator.Conditions.Required(value);
            },
            Message: "Please select From Account!"
        },
        toAccount: {
            Invalid: (value) => {
                return Validator.Conditions.Required(value);
            },
            Message: "Please select Account!"
        },
        accountID: {
            Invalid: (value) => {
                return Validator.Conditions.Required(value);
            },
            Message: "Please enter your Account ID!"
        },
        secureID: {
            Invalid: (value) => {
                return Validator.Conditions.Required(value);
            },
            Message: "Please enter your Secure ID!"
        },
        bankCode: {
            Invalid: (value) => {
                return Validator.Conditions.Required(value);
            },
            Message: "Please select Bank!"
        },
        transferType: {
            Invalid: (value) => {
                return Validator.Conditions.RequiredArray(value);
            },
            Message: "Please select Transfer Type!"
        },
        psp:{
            Invalid: (value) => {
                return Validator.Conditions.Required(value);
            },
            Message: "Please select PSP!"
        },
        description: {
            Invalid: (value) => {
                return Validator.Conditions.Required(value);
            },
            Message: "Description can not be empty!"
        }
    },
    Conditions: {
        Required(value) {
            return (value === null || value === "" || value === undefined);
        },
        RequiredArray(value) {            
            return (value.length < 1);
        },
        Max(value, max) {
            return (value > max);
        },
        Min(value, min) {
            return (value < min);
        },
        Numeric(value) {
            return isNaN(value);
        },
        MaxLength(value, length) {
            return (value.toString().length > length)
        },
        MinLength(value, length) {
            return (value.toString().length < length)
        }
    }


}

export const ErrorMessage = (props) => (
    <div className={"col-md-12 " + (props.Validation.error ? "" : "d-none")}>
        <div className={"alert alert-danger alert-dismissible fade show mb-3 mt-2" + (props.className || "")} role="alert">
            <strong><i className="fas fa-exclamation-triangle mr-1"></i> Error !</strong> {Translate(props.Validation.message)}
        </div>
    </div>
);

export const ConfirmMessage = (props) => (
    <div className={"col-md-12 " + (props.Validation2.error ? "d-none" : "")}>
        <div className={"alert alert-success alert-dismissible fade show mb-3 mt-2" + (props.className || "")} role="alert">
            <strong><i className="fas fa-exclamation-triangle mr-1"></i> success !</strong> {props.Validation2.message}
        </div>
    </div>
);

export const PortfolioMessage = (props) => {
    return (
        <div className={"col-md-12 " + (props.Validation3.error && !props.Validation3.message ? "d-none" : "")}>
            {!props.Validation3.error ? <div className={"alert alert-success alert-dismissible fade show mb-3 mt-2" + (props.className || "")} role="alert">
                <strong><i className="fas fa-exclamation mr-1"></i> Manuel cüzdana aktarım  başlatıldı. Bu işlem ağ yoğunluğuna bağlı olarak 15-20 dakika sürebilemektedir.</strong> {props.Validation3.message}
            </div> : <div className={"alert alert-danger alert-dismissible fade show mb-3 mt-2" + (props.className || "")} role="alert">
                <strong><i className="fas fa-exclamation mr-1"></i>
                    {props.Validation3.message}
                </strong>
            </div>}

        </div>
    );
};




export const VRules = (Validator.Rules);
export const VConditions = (Validator.Conditions);
